const sicentificBoard = [
  { position: 'position.univ_professor', affiliation: 'affiliation.lucian_blaga_university_of_sibiu', name: 'Constantin Chiriac'},
  { position: 'position.univ_professor', affiliation: 'affiliation.lucian_blaga_university_of_sibiu', name: 'Cristian Radu'},
  { position: 'position.univ_professor', affiliation: 'affiliation.new_sorbonne_university_paris_3', name: 'George Banu'},
  { position: 'position.univ_professor', affiliation: 'affiliation.leeds_beckett_university', name: 'Noel Witts'}
]

const walkOfFame = [
  'Ariane Mnouchkine',
  'Declan Donnellan',
  'Eugenio Barba',
  'Silviu Purcărete',
  'Gigi Căciuleanu',
  'Krystian Lupa',
  'Lev Dodin',
  'Peter Brook',
  'Peter Stein',
  'Klaus Maria Brandauer',
  '✝ Eimuntas Nekrošius',
  'Joël Pommerat',
  'Neil LaBute',
  'Kazuyoshi Kushida',
  'Alvis Hermanis',
  'Christoph Marthaler',
  'Evgeny Mironov',
  'Thomas Ostermeier',
  'Luk Perceval',
  'Tim Robbins',
  'Vasile Șirli',
  'Philippe Genty',
  'Rimas Tuminas',
  'Ohad Naharin',
  'Robert Wilson',
  'Mikhail Baryshnikov',
  'Ioan Holender',
  'Isabelle Huppert',
  'Wajdi Mouawad',
  'Hideki Noda',
  'Peter Sellars',
  'Sidi Larbi Cherkaoui',
  'Pippo Delbono',
  'Stan Lai',
  'Michael Thalheimer',
  'Emmanuel Demarcy-Mota'
  ]

const editorialBoard = [
  { position: 'position.univ_professor', affiliation: 'affiliation.lucian_blaga_university_of_sibiu', name: 'Constantin Chiriac', title: 'title.president' },
  { position: 'position.univ_professor', affiliation: 'affiliation.lucian_blaga_university_of_sibiu', name: 'Cristian Radu', title: 'title.editor_in_chief' },
  { position: 'position.univ_professor', affiliation: 'affiliation.lucian_blaga_university_of_sibiu', name: 'Ion M. Tomuș', title: 'title.associate_editor' },
  { position: 'position.assoc_professor', affiliation: 'affiliation.lucian_blaga_university_of_sibiu', name: 'Andrei Șerban', title: 'title.managing_editor' },
  { position: 'position.phd_student', affiliation: 'affiliation.lucian_blaga_university_of_sibiu', name: 'Cosmin Popescu', title: 'title.web_and_print' }
]

export { sicentificBoard, walkOfFame, editorialBoard }